import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { Container, Row, Col, Button } from 'react-bootstrap';
import { Formik, Form, Field, ErrorMessage } from 'formik';
import { subscribeNewsletter } from 'slices/newsletterSlice';
import Lottie from 'lottie-react-web';
import * as Yup from 'yup';
import newsletterImg from '../../assets/newsletter.svg';
import cpLoader from '../../assets/cp-loader-white.json';

const NewsLetter = () => {
  const dispatch = useDispatch();
  const { newsletterStatus, newsletter } = useSelector((state) => state.newsletter);

  const AccountSchema = Yup.object().shape({
    accountNumber: Yup.string()
      .min(5, 'Escribe un número de cuenta válido')
      .max(12, 'Escribe un número de cuenta válido')
      .required('Este campo es requerido')
      .matches(/^[0-9]/, '* Solo números'),
  });

  const [subscribed, setSuscribed] = useState('');

  const Suscription = () => {
    if (newsletter !== undefined) {
      if (newsletterStatus === 'success') {
        if (newsletter.status === 400) {
          setSuscribed('noValid');
        } else if (newsletter.status === 409) {
          setSuscribed('hasSuscribed');
        } else {
          setSuscribed('success');
        }
      }
    }
  };

  useEffect(() => {
    Suscription();
  }, [newsletterStatus]);

  return (
    <Container fluid className="bg-wafer text-tangaroa newsletter">
      <Container>
        <Row className="justify-content-center py-60">
          <Col xs={12} lg={4} className="text-center d-none d-lg-block d-xl-block">
            <img src={newsletterImg} alt="icon-newsletter" />
          </Col>
          <Col xs={12} lg={8}>
            <h2 className="py-15">
              Suscríbete para descubrir más Experiencias y Subastas Aeroméxico Rewards
            </h2>
            <p className="pb-15">
              Ingresa tu Número de Cuenta Aeroméxico Rewards, conoce nuestras Experiencias
              y Subastas antes que nadie.
            </p>
            <Formik
              initialValues={{
                code: 'YESSUB',
                accountNumber: '',
              }}
              validationSchema={AccountSchema}
              onSubmit={(valores, { resetForm }) => {
                resetForm();
                dispatch(subscribeNewsletter(valores));
                setSuscribed('');
              }}>
              {({ errors }) => (
                <Form className="header-group row">
                  <Col lg={6} className="pr-lg-0">
                    <div className="form-group">
                      <Field
                        className="input-group-box input-newsletter"
                        type="text"
                        name="accountNumber"
                        required
                        placeholder="Ingresa tu Número de Cuenta" />
                      <ErrorMessage
                        name="accountNumber"
                        component={() => (
                          <div className="mt-2 ml-3">{ errors.accountNumber }</div>)} />

                      {newsletterStatus === 'loading' && (
                        <Lottie
                          width={50}
                          options={{
                            animationData: cpLoader,
                          }} />
                      )}

                      {subscribed === 'noValid' && (
                        <small className="error-msg text-tangaroa">Escribe un No. de Cuenta válido</small>
                      )}
                      {subscribed === 'hasSuscribed' && (
                        <small className="error-msg text-tangaroa">{newsletter.data.message}</small>
                      )}
                      {subscribed === 'success' && (
                        <small className="error-msg text-tangaroa">
                          <i className="fas fa-check mr-10" />
                          ¡Te has suscrito correctamente!
                        </small>
                      )}

                    </div>
                  </Col>
                  <Col lg={3} className="pl-lg-0">
                    <Button variant="primary" type="submit" id="sbs-dsb-dgr-btn-sub" className="btn br-btn-hide-left btn-submit">
                      Suscribirme
                    </Button>
                  </Col>
                </Form>
              )}
            </Formik>
          </Col>
          <Col xs={12} className="text-center d-lg-none d-xl-none pt-30">
            <img src={newsletterImg} alt="icon-newsletter" />
          </Col>
        </Row>
      </Container>

    </Container>
  );
};

export default NewsLetter;
